module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// /causemisspiggynodeweb-ci-9188/workspace/Release/~/core-js/library/modules/_add-to-unscopables.js
// module id = 407
// module chunks = 0